import React from "react";
import { NewTab, PageHeader, PageTab, PageTitle } from "../../../components";
import AllVendors from "./Vendors/AllVendors";
import VendorsWithActiveConsultants from "./Vendors/VendorsWithActiveConsultants";

const Vendor = () => {
  const VendorMenus = [
    {
      title: "All Vendors",
      page: <AllVendors />,
      type: "main",
    },

    {
      title: "Vendors with Active Consultants",
      page: <VendorsWithActiveConsultants />,
      type: "main",
      // disabled: true,
    },

    {
      title: "Add Vendor",
      link: "/vendor/add-vendor",
      type: "sub",
      icon: "add",
    },
  ];
  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Vendor Management"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={VendorMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="vendor"
      />
      ;
    </>
  );
};

export default Vendor;
